import { ThemeConfig } from './themePalettes';

/**
 * Writes the theme on the document: one --theme-* custom property per
 * colour (camelCase to kebab-case), the data-theme* attributes the
 * stylesheets key on, and the legacy body classes.
 */
export const applyThemeToDom = (theme: ThemeConfig, isDark: boolean): void => {
  const root = document.documentElement;
  const { colors, animations, variant, reducedMotion } = theme;
  if (!colors) return;

  Object.entries(colors).forEach(([key, value]) => {
    const cssVar = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    root.style.setProperty(`--theme-${cssVar}`, value);
  });

  root.setAttribute('data-theme', isDark ? 'dark' : 'light');
  root.setAttribute('data-theme-variant', variant);
  root.setAttribute('data-animations', String(animations));
  root.setAttribute('data-reduced-motion', String(reducedMotion || false));

  document.body.classList.toggle('dark-theme', isDark);
  document.body.classList.toggle('light-theme', !isDark);
  document.body.classList.toggle('reduced-motion', reducedMotion);
};
